import React from 'react';
import { Result } from 'antd';

export default function UnsubscriptionError() {
  return (
    <Result
      status="error"
      subTitle={
        <>
          Unable to complete your request. It could happen when you clicked an
          invalid link. Please try again later or contact our{' '}
          <a href="mailto:support@turing.com">support</a>
        </>
      }
      title="Unsubscribe Failed"
    />
  );
}
